import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth71: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '38.1 118.5 35.7 115.8 33.6 111.4 31.8 106.2 31.8 92.7 35.1 89.3 39.3 85.9 43.6 83 161.2 83 166.6 89.7 168.4 94.5 169.1 98.6 168.9 107.9 165.5 114.8 163.7 118.5 38.1 118.5',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.8,76l-8.2,7-4.3,2.9-4.1,3.3-3.4,3.5v13.5l1.8,5.2,2.1,4.4,2.4,2.7,3.8,5.3,2.8,3.2,2.2,2.1,2.4,2.7s31.8-19.4,2.5-55.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148.8,74.9l3.2,1.2,4.7,2.9,4.5,4,5.4,6.7,1.8,4.7.7,4.3-.2,9.4-5.2,10.6-4.9,7.6-5.3,5.2s-37.5-28.9-4.8-56.4Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.4,95.1s60.8,30.3,136.3,0v11.2c-.1,0-2.1,7.7-2.1,7.7l-3.9,7.2-6,7.8-7.2,5.9-10.1,5-15.7,5.3-14.8,4.1h-2c0,.1-13.6.1-13.6.1l-17.4-3.8-12.9-4.1-8.1-4.4-10.8-9.7-5.2-7.3-4.6-7.5-2.4-6.2-.4-7.2,1-4.2Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M32.4,95.1l2-5.1,10.6-7.9,12.6-10,17.9-13.7,11.9-8,5.9-3.4,2.8-1h7.7l4.5,1.1,5.3,3.5,8.8,6.4,9.3,7.7,7.7,6.4,9.4,3.8,7.9,3.9,4.8,4.4,3.2,3.8,2.2,3.7,1.8,4.3s-66.2,31.4-136.3,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M103.4,149.5c-7.6,1-14.1-1.5-20.9-3.1s-17.7-3.5-25.5-8.5c-14.9-9.8-32.4-32.7-22.1-48.8,6.4-3.7,12.1-7.5,16.8-13.2,21.6-11.6,40.9-40.7,62.1-24.5l26.6,20.2c6.5,4.9,15.3,5.9,20.9,12,7.5,8.2,9.6,18.3,5.3,28.4-4.1,9.7-10.6,18.4-19.6,24.1s-10.5,4.2-15.8,6.2c-8.9,3.2-17.8,6.2-27.7,7.4Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M34.2,443.5v11.5c-.1,0,.1,3.8.1,3.8l2.5,3.6,3.7,3,3.8,1.6,4.3.6,18.9.6,17.9,1.2,27.7.4,28.5-1.1,10-3,5.5-7.2,2.1-7,1.4-7.1s-126.4-.4-126.4-.9Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M40.9,383.6l-5.5,39.3s57.3-11.7,5.5-39.3Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.1,383l5.4,39.8s-54.1-16.5-5.4-39.8Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M114.2,372.5A15.6,15.6 0 1 0 83,372.5A15.6,15.6 0 1 0 114.2,372.5Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M55.9,327.2l3-14s34.3-24.2,81.7,0l1.9,13s-45.4-32.7-86.6,1Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M77.5,469l-28.3-1.1-4.9-.8-4.1-1.6-3.3-3-2.5-3.6v-15.3c-.1,0,1.1-20.7,1.1-20.7l2.6-20.5,2.9-18.7,4.3-23.3,6.3-18.7c26.3,8.5,26.1,127.3,26.1,127.3Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M146,342.7l1.9,8.7,5.5,19.5,1.7,12.1,5.4,39.8.6,3.3-.5,18.3-3.5,14.2-5.5,7.2-10,3-26.1,1.1s4.2-121.3,30.5-127.2Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M48.6,467.6l-4.3-.6-4.1-1.6-3.3-3-2.5-3.6-.3-3.7.2-11.7,1.3-20.6,2.6-20.5,2.9-18.8,4.3-23.2,6.3-18.7,4.5-14.7s36.4-33.2,86.5-.6l3.5,16.5,7.4,28.2,7.7,55.2-.5,18.3-3.5,14.2-5.5,7.2-10,3-26.1,1.1-30.6-.4-36.3-1.9Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M84.4,469l-21.9-1.8c-6.7-.5-25.1,2-27.3-8.5-1.7-7.7-1.1-15.1-.4-23,2.1-22.4,5.1-44.2,8.5-66.5l4.2-15.9c1.8-6.7,4.8-12.7,6.4-19.4,19.9-21.6,48.5-33.1,72-12.8,8.9,7.7,15.5,17.2,21.1,27.7l6,23,6.9,48.1c1.8,12.7,1.2,25.2-2.8,37-5.2,15-24.3,10.5-43.1,12.1s-19,.8-29.5,0Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M67.7,117.4h62.5s-29.8,128.7-62.5,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M167.3,58.7l.8,15.8-3.3,18.3s-50-21.4,2.5-34.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.9,58l1,34.6s50.7-19.9-1-34.6Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '38.1 47.3 39.1 39.9 42.2 35.7 46.7 32.5 51.8 31.4 57.9 30.1 83.2 29 98.7 28.1 110.6 27.9 121.6 29.3 134.4 30.7 146.8 32.4 153.3 33.6 158.2 35.8 164.3 40.7 165.6 44.2 166.3 48 38.1 47.3',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.3,164.2s48.6,59.1,95,0l-3.5,16.8s-32.9,48.3-88.5,0l-3-16.8Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M46,146.2l-3.3-17.1-2-13.8-.8-8.2-1-14.5-1-34.6.2-10.7,1-7.4,3-4.3,4.8-3.3,10.9-2.3,25.3-1.1s-15,104-37.2,117.2Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.3,40.7l2,7.3.9,6.3v4.4c0,0,.9,15.8.9,15.8l-3.3,18.3-7.9,40.4-3.9,13.3c-24.6-9.8-28-116.7-28-116.7l21.1,2.4,7.2,1.3,5,2.2,6.1,4.9Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.3,164.2l-5.4-18-3.3-17.1-2-13.8-1.3-15.7-.4-5-.5-11.2-.2-6.6-.3-10.4v-14.6c0,0-.2-4.7-.2-4.7l1.2-7.1,3-4.3,4.4-3.1,11.3-2.4,40.6-2h12.2c0-.1,35.3,4.2,35.3,4.2l7.2,1.3,5,2.2,6,4.9,1.2,3.5.8,3.9.9,6.2v4.4c0,0,.8,14.2.8,14.2v2s-11.1,58.3-11.1,58.3l-3.9,13.3-6.7,17.7s-42.2,60.7-95,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M148,159.4c-16.3,26.5-45.9,50.8-73.8,29.1-10.4-8.1-19.3-18.8-24.3-31.1-9.1-22.5-10.6-61.1-11.6-87.4-.3-8.8-.1-17.3.7-26,1.2-13.8,16.7-12.9,30-13.4,15.5-.6,30.5-2.8,46-1.1l31.5,3.4c6.3.7,15.2,3.4,17.6,9.9,4.9,13.5,4.4,28.2,1.7,42.1l-7.9,41.1c-2.2,11.6-6.2,21.8-9.8,33.4Z',
			},
		},
	},
};
